import { addDoc, collection } from "firebase/firestore";
import { db } from "./firebase";

export async function sendNotification(recipientId, messageDe, messageEn) {
  try {
    await addDoc(collection(db, "notifications"), {
      recipientId: recipientId,
      messageDe: messageDe,
      messageEn: messageEn,
      read: false,
      createdAt: new Date().toISOString(),
    });
  } catch (err) {
    console.error("Notification error:", err);
  }
}
